import SelectField from '@Fields/SelectField';
import TextField from '@Fields/TextField';

class ConsignmentInfoForm extends React.Component {

    static modelToState(props) {

        var selectedLocations = [];
        var nonSelectedLocations = [];
        var count = 0;
        for (let key in props.model.Auctioneers) {
            var auctioneer = props.model.Auctioneers[key];

            if (count <= 4 && props.model.AuctioneerCheckBoxHandler[key]) {
                selectedLocations.push(auctioneer);
                count = count++;
            }
            else {
                nonSelectedLocations.push(auctioneer);
            }

            count++
        };

        return {
            AuctioneerCheckBoxHandler: props.model.AuctioneerCheckBoxHandler,
            Auctioneers: props.model.Auctioneers,
            SelectedLocations: selectedLocations,
            NonSelectedLocations: nonSelectedLocations,
            PreferredSaleDateList: props.model.PreferredSaleDateList,
            PreferredSaleDateSelected: props.model.PreferredSaleDateSelected,
            IsRegisteredUser: props.model.IsRegisteredUser,
            CurrentSite: props.model.CurrentSite,
            QueryString: props.model.QueryString,
            Translations: props.model.Translations,
            HighlightErrors: {},
            FormErrors: [],
            InputErrors: {},
            IsInTranslationEditorMode: props.model.IsInTranslationEditorMode
        };
    }

    constructor(props) {
        super(props);

        this.state = ConsignmentInfoForm.modelToState(props);

        this.handleFormUpdate = this.handleFormUpdate.bind(this);
        this._lastAutoSelectLocationKey = null;
    }

    tryAutoSelectAuctioneers() {
        if (this.state.IsRegisteredUser) return;
        if (!this.props.masterViewModel) return;

        var locationVM = this.props.masterViewModel.ContactViewModel &&
            this.props.masterViewModel.ContactViewModel.LocationViewModel;

        if (!locationVM || (!locationVM.PostalCode && !locationVM.State)) return;

        var locationKey = (locationVM.City || '') + '|' + (locationVM.State || '') + '|' + (locationVM.PostalCode || '') + '|' + (locationVM.Country || '');
        if (locationKey === this._lastAutoSelectLocationKey) return;

        this._lastAutoSelectLocationKey = locationKey;

        var endpoint, objectToSend;

        if (locationVM.PostalCode) {
            endpoint = '/listinginput/ajax/GetLatLongFromPostalCode';
            objectToSend = { postalCode: locationVM.PostalCode };
        } else {
            endpoint = '/listinginput/Location/GetLatLongFromAddress';
            objectToSend = {
                city: locationVM.City || '',
                state: locationVM.State || '',
                country: locationVM.Country || ''
            };
        }

        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            if (xhr.status == 200) {
                var response = JSON.parse(xhr.response);
                if (response && response.latitude && response.longitude && !response.error) {
                    var clearedHandler = this.state.AuctioneerCheckBoxHandler;
                    Object.keys(clearedHandler).forEach(k => {
                        clearedHandler[k] = false;
                    });
                    var selection = chooseAuctioneers(this.state.Auctioneers, clearedHandler, response.latitude, response.longitude, true);
                    this.setState({
                        AuctioneerCheckBoxHandler: selection.auctioneerCheckBoxHandler
                    }, function () {
                        this.handleFormUpdate(this.state);
                    });
                }
            }
        }.bind(this);

        xhr.open("POST", endpoint, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(JSON.stringify(objectToSend));
    }

    componentDidMount() {
        this.tryAutoSelectAuctioneers();
    }

    componentWillReceiveProps(Props) {
        this.setState({
            HighlightErrors: Props.model.HighlightErrors,
            FormErrors: Props.model.FormErrors,
            InputErrors: Props.model.InputErrors
        }, () => {
            this.tryAutoSelectAuctioneers();
        });
    }

    //will execute AFTER the state has receieved all the props. 
    //componentDidMount() {
    //    //initialize map when doc is ready, and you have set state to a variable. Jquery won't see this.state in the doc ready function
    //    var state = this.state;
    //    $(document).ready(function () {
    //        if (state.SelectedLocations.length > 0) {
    //            loadMarkers(state.SelectedLocations, true);
    //        }
    //        loadMarkers(state.NonSelectedLocations, false);
    //    });
    //}

    //React handle Methods
    handleFormUpdate(Model) {
        this.setState({
            AuctioneerCheckBoxHandler: Model.AuctioneerCheckBoxHandler,
            Auctioneers: Model.Auctioneers,
            PreferredSaleDateList: Model.PreferredSaleDateList,
            PreferredSaleDateSelected: Model.PreferredSaleDateSelected,
            PostalCode: Model.PostalCode,
        });

        //update parent component
        this.props.handleFormUpdate(Model);
    }

    //handleMasterUpdate(Model) {
    //    var masterViewState = this.props.masterViewModel;
    //    masterViewState.ContactViewModel = Model;
    //    this.props.handleFormUpdate(masterViewState);
    //}

    handleFieldChanged(field, value) {
        var state = this.state;

        if (field.indexOf("AuctioneerCheckBoxHandler:") > -1) {
            var scrmid = field.split('AuctioneerCheckBoxHandler:')[1];
            var crmid = parseInt(scrmid);

            state.AuctioneerCheckBoxHandler[crmid] = value;

            //change text and pin color on the mpa
            if (markers[crmid].content.currentSrc.includes("gray-pin")) {
                setMarkerIcon(markers[crmid], redPin, crmid, TranslationRemoveAuctioneer);
            }
            else {
                setMarkerIcon(markers[crmid], grayPin, crmid, TranslationAddAuctioneer);
            }

            delete state.InputErrors["AuctioneerCheckBoxHandler"];
        }
        else {
            switch (field) {
                case "PreferredSaleDateSelected":
                    state[field] = value;
                    delete state.HighlightErrors["PreferredSaleDateSelected"];
                    delete state.InputErrors["PreferredSaleDateSelected"];
                    break;
                case "AuctioneerFromMap":   //this case is when input is made from the map 
                    var sCRMID = value.split("value")[0];
                    var crmid = parseInt(sCRMID);
                    var val = value.split("value")[1] == "true";
                    state.AuctioneerCheckBoxHandler[crmid] = val;

                    delete state.InputErrors["AuctioneerCheckBoxHandler"];
                    break;
                case "PostalCode":
                    state[field] = value;
            }
        }

        this.handleFormUpdate(state);
    }

    handleButtonClick(btn) {
        switch (btn) {
            case "UseLocation":
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        (position) => {
                            //user allowed location access

                            var clearedAuctioneerCheckBoxHandler = this.state.AuctioneerCheckBoxHandler;
                            Object.keys(clearedAuctioneerCheckBoxHandler).forEach(k => {
                                clearedAuctioneerCheckBoxHandler[k] = false;
                            });

                            var selection = chooseAuctioneers(this.state.Auctioneers, clearedAuctioneerCheckBoxHandler, position.coords.latitude, position.coords.longitude, true);
                            this.setState({
                                ...this.state,
                                AuctioneerCheckBoxHandler: selection.auctioneerCheckBoxHandler
                            });
                        },
                        () => {
                            //user rejected location
                            this.showPostalCodeEntry();
                        }
                    );
                }
                else {
                    // Browser doesn't support Geolocation so show postalcode entry
                    this.showPostalCodeEntry();
                }
                break;
            case "usePostalCode":
                var objectToSend = {
                    postalCode: this.state.PostalCode,
                };

                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    var response;
                    if (xhr.status == 200) {
                        response = JSON.parse(xhr.response);
                    }
                    else {
                        return;
                    }

                    if (response && response.latitude && response.longitude && !response.error) {
                        var clearedAuctioneerCheckBoxHandler = this.state.AuctioneerCheckBoxHandler
                        //if a postal code is entered we don't want to double up so clear this current
                        Object.keys(clearedAuctioneerCheckBoxHandler).forEach(k => {
                            clearedAuctioneerCheckBoxHandler[k] = false;
                        })
                        var selection = chooseAuctioneers(this.state.Auctioneers, clearedAuctioneerCheckBoxHandler, response.latitude, response.longitude, true)
                        this.setState({
                            ...this.state,
                            AuctioneerCheckBoxHandler: selection.auctioneerCheckBoxHandler
                        });

                        var txtPostalCode = document.getElementById("ConsignmentPostalCode");
                        txtPostalCode.style.boxShadow = "none";
                        var lblPostalCodeError = document.getElementById("ConsignmentPostalCodeError");
                        lblPostalCodeError.style.display = "none";
                    }
                    else {
                        var txtPostalCode = document.getElementById("ConsignmentPostalCode");
                        txtPostalCode.style.boxShadow = "rgb(204, 0, 0) 0px 0px 5px";
                        var lblPostalCodeError = document.getElementById("ConsignmentPostalCodeError");
                        lblPostalCodeError.style.display = "inherit";
                    }

                }.bind(this);

                xhr.open("POST", '/listinginput/ajax/GetLatLongFromPostalCode', true);
                xhr.setRequestHeader("Content-type", "application/json");
                xhr.send(JSON.stringify(objectToSend));
                break;
        }
    }

    showPostalCodeEntry() {
        var postalCodeEntry = document.getElementById('usePostalCodeContainer');
        if (postalCodeEntry) {
            postalCodeEntry.style.display = "flex";
            var btnUseLocation = document.getElementById('btnUseLocation');
            if (btnUseLocation) {
                btnUseLocation.style.display = "none";
            }
        }
    }

    getTranslation(key) {
        return this.state.IsInTranslationEditorMode ?
            <span dangerouslySetInnerHTML={{ __html: this.state.Translations[key] }}></span> :
            this.state.Translations[key];
    }

    //render
    render() {
        var preferredDateDDL = [];
        for (let key in this.state.PreferredSaleDateList) {
            preferredDateDDL.push({ text: key, value: this.state.PreferredSaleDateList[key] });
        };

        //auctioneer checkboxes
        var auctioneerCheckBoxes = [];
        for (let key in this.state.AuctioneerCheckBoxHandler) {
            if (this.state.AuctioneerCheckBoxHandler[key]) {
                var auctioneer = this.state.Auctioneers[key];
                let id = "AuctioneerCheckBoxHandler:" + key.toString();
                auctioneerCheckBoxes.push(
                    <div key={key} className="cbContainer">
                        <TextField
                            type="checkbox"
                            className="cbAuctioneer"
                            id={id}
                            value={this.state.AuctioneerCheckBoxHandler[key]}
                            onFieldChanged={(e) => { this.handleFieldChanged(id, e); }}
                            inline={true}
                            hasLabel={true}
                        />
                        <label htmlFor={id}><strong>{auctioneer.ParentAccountName}</strong></label>
                        <div style={{ marginLeft: '22px' }}>
                            {auctioneer.ShippingCity}, {auctioneer.ShippingState} {auctioneer.ShippingPostalCode}
                        </div>
                    </div>
                );
            }
        };

        var requiredText = [];
        if (auctioneerCheckBoxes.length == 0) {
            requiredText.push(<strong key="requiredText" style={{ color: '#B12C1B' }}>{this.getTranslation("Required")}</strong>);
        }

        return (
            <div>
                {/*Preferred Sale Date - Will not render if the PreferredSaleDateList is empty*/}
                {(preferredDateDDL != null && preferredDateDDL.length > 0) &&
                    <div className="form-row cf">
                        <label className="label-left" htmlFor="PreferredSaleDateSelected">{this.getTranslation("PreferredSaleDate")}</label>
                        <div className="input-right">
                            <SelectField
                                id="PreferredSaleDateSelected"
                                value={this.state.PreferredSaleDateSelected}
                                className="PreferredSaleDateSelected"
                                values={preferredDateDDL}
                                onFieldChanged={(e) => { this.handleFieldChanged("PreferredSaleDateSelected", e); }}
                                error={this.state.HighlightErrors.PreferredSaleDateSelected}
                                errorText={this.state.InputErrors.PreferredSaleDateSelected}
                                hasLabel={true}
                            />
                        </div>
                    </div>
                }

                {/*Hidden field needed to dispatch an event in jquery and land here in React*/}
                <div className="form-row cf" style={{ display: 'none' }}>
                    <label className="label-left" htmlFor="AuctioneerFromMap"> Auctioneer From Map </label>
                    <div className="input-right">
                        <TextField
                            id="AuctioneerFromMap"
                            value={this.state.PreferredSaleDateSelected}
                            onFieldChanged={(e) => { this.handleFieldChanged("AuctioneerFromMap", e); }}
                            hasLabel={true}
                        />
                    </div>
                </div>

                {/*Auctioneers*/}
                <div className="form-row cf">
                    <span style={{ display: 'block' }}>{this.getTranslation("AuctioneerToReceive")}:</span>
                    {auctioneerCheckBoxes}
                </div>

                <div id="divAuctioneerSelector">
                    <div className="bodygray" style={{ padding: '10px 9px' }}>
                        <strong>{this.getTranslation("ChooseAdditionalAuctioneers")}: {requiredText}</strong>
                        <div className="locationContainer">
                            <button role="link" id="btnUseLocation" className="locationBtn PrimaryBGC siteFontColor" onClick={(e) => { this.handleButtonClick("UseLocation"); }}>{this.getTranslation("UseMyCurrentLocation")}</button>
                            <div style={{ display: 'none' }} id="usePostalCodeContainer" className="usePostalCodeContainer">
                                <label className="postalCodeLabel" htmlFor="ConsignmentPostalCode">{this.getTranslation("PostalCode")}</label>
                                <TextField
                                    id="ConsignmentPostalCode"
                                    className="postalCodeInput"
                                    value={this.state.PostalCode}
                                    onFieldChanged={(e) => { this.handleFieldChanged("PostalCode", e) }}
                                    error={this.state.HighlightErrors.PostalCode}
                                    errorText={this.state.InputErrors.PostalCode}
                                    hasLabel={true}
                                />

                                <button className="usePostalCode PrimaryBGC siteFontColor" onClick={(e) => { this.handleButtonClick("usePostalCode") }} title={this.getTranslation("Search")}>
                                    <i className="fas fa-crosshairs" aria-hidden="true"></i>
                                </button>
                                <span id="ConsignmentPostalCodeError" className="postalCodeError" style={{ display: "none" }}>{this.getTranslation("PostalCodeInvalid")}</span>
                            </div>
                        </div>
                    </div>
                    <div id="js-google_map" className="js-google_map" style={{ height: '500px' }}> </div>
                </div>
            </div>
        );
    }
}

export default ConsignmentInfoForm;
global.ConsignmentInfoForm = ConsignmentInfoForm;